import React from "react";
import Product from "./Product"
import BasketTotal from "./BasketTotal";

function Basket(props) {
  return (
    <div className="basket">
      
      {props.basketCount > 0 ? (props.basket.map(item => 
              <Product key={item.trackId} 
                       item={item} 
                       trackId={item.trackId} 
                       removeFromBasket={props.removeFromBasket}/>))
                       :<div className="empty">Sorry, no items in basket...</div>}

      <br/><h2>Total: £
        <BasketTotal
          basketCount={props.basketCount}
          basketTotal={props.basketTotal}
          basket={props.basket}
        /></h2>
  
    </div>
  );
}

export default Basket;